import { ViewWithLoader } from "@/components/v2/ViewWithLoader";
import { useTrans } from "@/translations";

import { useContext } from "react";

import { LibraryPageContext } from "../../../../context";
import { FileStatus } from "../../../../types";
import { CreateFolderView } from "./components/createFolderView";
import { FoldersListView } from "./components/foldersListView";
import { MainFolderView } from "./components/mainFolderView";

export const FolderList: React.FC = () => {
  const { t } = useTrans();
  const { isFetchingFolders } = useContext(LibraryPageContext);

  return (
    <aside className="border-grey2 border-r px-3 py-[14px]">
      <ViewWithLoader isLoading={isFetchingFolders}>
        <div className="px-2 pt-[5px] pb-2 text-[11px] font-bold tracking-[0.07em] text-[#9a958f] uppercase">
          {t("libraryPage:folderListTitle")}
        </div>

        <MainFolderView value={FileStatus.PUBLISHED} />

        <FoldersListView />

        <MainFolderView value={FileStatus.ARCHIVED} />

        <CreateFolderView />
      </ViewWithLoader>
    </aside>
  );
};
